angular.module('stack.common.ui.loader.stackLoader', [])

/**
 * The Loader directive wraps other directive implementations
 * and provides a uniform loading mechanism.
 *
 * @class Loader
 * @constructor
 * @module stack.common.ui.loader.stackLoader
 * @example
 *   // Default implementation.
 *   <stack-loader>
 *     <stack-login></stack-login>
 *   </stack-loader>
 *
 *   // Alternatively, the Loader directive takes a show (String) parameter
 *   // and a hide (String) parameter. As their names indicate, calling either
 *   // action from outside the loader results in the controlled showing and
 *   // hiding of content. This is useful when undelying directives request
 *   // data and need to hide their respective interfaces for a brief period.
 *   <stack-loader opaque="true" show="component:action" hide="component:action">
 *     <stack-login></stack-login>
 *   </stack-loader>
 */
.directive('stackLoader', [
  '$timeout',
  function ($timeout) {
    'use strict';

    return {
      restrict: 'E',
      scope: {},
      transclude: true,
      templateUrl: 'js/src/stack/common/ui/loader/loader.html',
      link: function (scope, element, attrs) {
        /**
         * Property houses the loading flag.
         *
         * @property loader
         * @type {boolean}
         */
        scope.loader = true;

        /**
         * Property houses the opaque flag.
         *
         * @property opaque
         * @type {boolean}
         */
        scope.opaque = false;

        /**
         * Method automatically lowers the loading screen
         * after a single second after the initialization
         * process completes.
         *
         * @private
         */
        function reveal() {
          var t;
          scope.loader = true;

          t = $timeout(function () {
            scope.loader = false;
            $timeout.cancel(t);
          }, 1000);
        }

        /**
         * Method renders the loading screen. This method is only
         * triggered when custom events are passed into the Loader
         * directive through the attrs.show property.
         *
         * @private
         */
        function onShowLoader() {
          scope.loader = true;
        }

        /**
         * Method prevents tabbing under the loader
         * when the loader is enabled.
         *
         * @param {Object} evt - Event object
         * @private
         */
        function onKeydownLoader(evt) {
          if (evt.keyCode === 9 && scope.loader) {
            evt.preventDefault();
          }
        }

        /**
         * Method lowers the loading screen. This method is only
         * triggered when custom events are passed into the Loader
         * directive through the attrs.hide property.
         *
         * @private
         */
        function onHideLoader() {
          reveal();
        }

        /**
         * Method configures listeners during the initialization process.
         *
         * @private
         */
        function defineListeners() {
          if (attrs.show) {
            scope.$on(attrs.show, onShowLoader);
          }

          if (attrs.hide) {
            scope.$on(attrs.hide, onHideLoader);
          }

          if (attrs.opaque) {
            scope.opaque = scope.$eval(attrs.opaque);
          }

          element.on('keydown', onKeydownLoader);
        }

        /**
         * Method executes the initialization process.
         *
         * @private
         */
        function initialize() {
          defineListeners();
          reveal();
        }
        initialize();
      }
    };
  }
]);
